module.exports = __webpack_public_path__ + "static/media/alert.7dbb1867.svg";